module.exports = __webpack_public_path__ + "9c0e03c3607868ad0bdc059fd8a50733.png";